<template>
    <div class="porlet-buscador">
        
        <TableElement
        @close="closedDrawerSearch"
        @dblclick="closedDrawerSearch"
        tipo="cuadromando"
        ref="datatable_buscador"
        :ficha="ficha"
        :pageCount="2"
        :autoReload="true"
        :fullscreen="drawerSearchFullscreen"
        :entidad="entidad"
        :entidadRelacionada="ficha && ficha.buscador && ficha.buscador[0].valor || 'todos'"
        :visibleReload="true"
        :visibleSetFullScreen="true"
        :porlet="porlet"
        />

    </div>
</template>

<script>
    import TableElement from '@/components/Porlet/PorletTableElement.vue'
    export default {
		name: 'Buscador',
		components: {
			TableElement
		},
		props: {
            ficha: Object,
            entidad: String,
            drawerSearchFullscreen: {
                type: Boolean,
                default: false
            },
            porlet: {
                type: Object
            }
		},
        mounted() {
            this.init()
        },
		methods: {
            init() {

				let key = `datatable_buscador`

				this.$addRef(key, this.$refs[key])
				
            },
            closedDrawerSearch(value,dblclick) {
                
                if (value == null) return

                this.$emit("closedDrawerSearch", {value,dblclick})

                this.$emit("dblClickSearch", {value,dblclick})


                if (this.porlet.entidadRelacionada) {
                    this.$emit("openWindow", {...value, entidad: this.porlet.entidadRelacionada})
                } else {
                    this.$emit("openWindow", value)
                }
                
            }
		}
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.porlet-buscador {
    //padding: 15px;

    .porlet-buscador-filter {
        background-color: white;
        padding: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.08);
    }

    .porlet-buscador-content {
    }

    .table-content {
        background-color: unset;

        // Paginacion
        .el-pager li {
            background-color: unset;
        }
        .el-pagination {
            .btn-next,
            .btn-prev {
                background-color: unset;
            }
        }

        // Columnas
       .cell .col-title {
           background-color: $--color-header!important;
           p {
                color: white!important;
           }
       }
    }
    
}
</style>
